import { animateScroll as scroll } from 'react-scroll';

import { TgIcon, UpIcon, VkIcon } from 'src/assets/icons';
import LogoSecondIcon2 from 'src/assets/icons/logoSecond.svg';
import { useWindowWidth } from 'src/hooks';

import styles from './Footer.module.scss';

const Footer = () => {
  const width = useWindowWidth();

  const scrollToTop = () => {
    scroll.scrollToTop();
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <div className={styles.logoWrapper}>
          <img className={styles.logo} src={LogoSecondIcon2} alt="logo" />
          {width <= 1100 && (
            <div className={styles.social}>
              <a className={styles.icon} target="_blank" href="https://t.me/sib_industry_fashion">
                <TgIcon />
              </a>
              <a className={styles.icon} target="_blank" href="https://vk.com/industry_art">
                <VkIcon />
              </a>
            </div>
          )}
        </div>
        <address className={styles.address}>
          <a href="https://yandex.ru/maps/-/CDqZr-ye" className={styles.map}>
            г. Красноярск, ул. Красной Армии, д. 10, стр 4, пом. 3В
          </a>
          <a className={styles.tel} href="tel:+79135923844">
            +7 (391) 219 19 69
          </a>
          <a className={styles.email} href="mailto:info@industry.art">
            info@industry.art
          </a>
        </address>
        {width > 1100 ? (
          <div className={styles.social}>
            <a className={styles.icon} target="_blank" href="https://t.me/sib_industry_fashion">
              <TgIcon />
            </a>
            <a className={styles.icon} target="_blank" href="https://vk.com/industry_art">
              <VkIcon />
            </a>
          </div>
        ) : (
          <div className={styles.socialUp}>
            <UpIcon onClick={scrollToTop} />
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
